import React, { useState } from 'react';
import { graphql} from "gatsby";
import styled from 'styled-components';
import Masonry from 'react-masonry-component';

import Layout from "../components/layout"
import PostCard from '../components/postCard';
import Hero from "../components/sections/hero"
import Seo from '../components/seo';


const Content = styled(Masonry)`
  max-width: 1200px;
  min-height: 80vh;
  margin: auto;
  article{
    margin: 1%;
    width: ${props => (100 - 2 * props.columns) / props.columns}%;
    
    @media (min-width: 480px) and (max-width: 1024px) {

    width: 48%;
    }
    @media (max-width: 480px) {
    width: 100%;
    margin:10px 0;
    }
  }
  
`;
const LoadMoreStyle = styled.div`
  	margin: 40px 0 30px 0;
	text-align: center;
	button{
		background-color: transparent;
	}
`;
const IndexPage = ({location,pageContext,data}) => {

const title = data.site.siteMetadata.title;
const Posts = data.allMarkdownRemark.edges;
const TotalPost = data.allMarkdownRemark.edges.length;

const [state, setState] = useState({
    visibile: 8,
  });

  const [load, setload] = useState({
    loading: false,
  });

  const fetchMoreData = () => {
  
    setload({ loading: true });

    setTimeout(function () {
      setState((prev) => {
        return { visibile: prev.visibile + 8 };
      });
      setload({ loading: false });
    }, 1000);
  };
const LoadingIcon = (props) => {

    return (
      <svg className = {props.Style} width="60" height="60" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="more"><circle cx="3" cy="10" r="2"></circle><circle cx="10" cy="10" r="2"></circle><circle cx="17" cy="10" r="2"></circle></svg>
    );
  };

return (
  <Layout location={location}>
    <>
     <Seo title={title}
  		  location={location}/>
    	<Hero/>
    		<Content columns={3}>
    			{Posts.slice(0, state.visibile).map(({ node }) => {
            		return (
              			<PostCard
              				key={node.fields.slug}
              				node={node}
            			/>
            		);
          		})}
    		</Content>
    
    		<LoadMoreStyle>
          		{state.visibile < TotalPost ? (
           			<button type="submit"
              		onClick={fetchMoreData}>{load.loading ? <LoadingIcon Style="rotate"/> : <LoadingIcon />}</button>
          		) : (
            		<p>No more posts</p>
          		)}
       		</LoadMoreStyle> 
    </>
    
  </Layout>
 )
}

export default IndexPage


export const listingQuery = graphql`
  query IndexQuery{
    site {
      siteMetadata {
        title
        description
        siteUrl
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
    totalCount
      edges {
        node {
          fields {
            slug
          }
          excerpt
          
          frontmatter {
            title
            tags
            description
            cover{
              childImageSharp {
                gatsbyImageData(width: 500 , layout: CONSTRAINED)
         		
              }
            }
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`;
